// extracted by mini-css-extract-plugin
export default {"container":"BookDetails_container__nZFGB","content":"BookDetails_content__bwS4U"};